import {
  AFFIRMATION_LIST,
  ANIMATION_LIST,
  BREATHING_LIST,
  EMAIL_PUSH_LIST,
  INSPIRATION_LIST,
  LANGUAGES_LIST,
  MEDIDATION_CATEGORY_LIST,
  MEDIDATION_LIST,
  MUSIC_LIST,
  MUSIC_NATURE_SOUND_LIST,
  PROMOCODE_LIST,
  REMINDER_LIST,
  SLEEP_STORY_LIST,
  USER_LIST,
  DOCUMENTS,
  STATISTICS,
  MUSIC_CATEGORY_LIST,
  SLEEP_STORY_CATEGORY_LIST,
  MUSIC_NATURE_SOUND_MIX_LIST,
  LEVEL_LIST,
  REWARD_LIST,
} from "@/route-names";
import { Route } from "vue-router";
import MenuItem from "./menuItem";
// import router from "../router";

class MenuItemFactory {
  /**
   * Меню проектов начало
   */
  static PageMeditationList = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#meditation",
    prefix: "page-meditation-list",
    name: "Медитации",
    routeName: MEDIDATION_LIST,
    childs: [],
  });
  static PageMeditationCategoryList = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#meditation",
    prefix: "page-meditation-categories",
    name: "Категории",
    routeName: MEDIDATION_CATEGORY_LIST,
    childs: [],
  });
  static PageMeditation = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#meditation",
    prefix: "page-meditation",
    name: "Медитации",
    routeName: MEDIDATION_LIST,
    childs: [
      MenuItemFactory.PageMeditationList,
      MenuItemFactory.PageMeditationCategoryList,
    ],
  });
  static PageAffirmations = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#affirmations",
    prefix: "",
    name: "Аффирмации",
    routeName: AFFIRMATION_LIST,
    childs: [],
  });

  static PageMusicOfNature = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#music-of-nature",
    prefix: "page-music-nature",
    name: "Звуки природы",
    routeName: MUSIC_NATURE_SOUND_LIST,
    childs: [],
  });
  static PageMusicMixOfNature = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#music-of-nature",
    prefix: "page-nature-sound-mix",
    name: "Миксы звуков",
    routeName: MUSIC_NATURE_SOUND_MIX_LIST,
    childs: [],
  });

  static PageMusicDaughter = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#music-daughter",
    prefix: "page-music-daughter",
    name: "Музыка",
    routeName: MUSIC_LIST,
    childs: [],
  });
  static PageMusicCategories = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#music-categories",
    prefix: "page-music-categories",
    name: "Категории музыки",
    routeName: MUSIC_CATEGORY_LIST,
    childs: [],
  });
  static PageMusic = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#music",
    prefix: "page-music",
    name: "Музыка",
    routeName: MUSIC_LIST,
    childs: [
      MenuItemFactory.PageMusicDaughter,
      MenuItemFactory.PageMusicOfNature,
      MenuItemFactory.PageMusicMixOfNature,
      MenuItemFactory.PageMusicCategories,
    ],
  });

  static PageUsers = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#users",
    prefix: "",
    name: "Пользователи",
    routeName: USER_LIST,
    childs: [],
  });
  static PagePromocode = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#promocode",
    prefix: "",
    name: "Промокоды",
    routeName: PROMOCODE_LIST,
    childs: [],
  });

  static PageEmailPush = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#promocode",
    prefix: "page-email-push",
    name: "Email и Пуши",
    routeName: EMAIL_PUSH_LIST,
    childs: [],
  });

  static PageInspiration = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#lamp",
    prefix: "",
    name: "Вдохновение",
    routeName: INSPIRATION_LIST,
    childs: [],
  });

  static PageSleepStoriesPage = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#sleep-stories",
    prefix: "page-sleep-stories",
    name: "Сонные истории",
    routeName: SLEEP_STORY_LIST,
    childs: [],
  });
  static PageSleepStoryCategories = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#sleep-story-categories",
    prefix: "page-sleep-story-categories",
    name: "Категории сонных историй",
    routeName: SLEEP_STORY_CATEGORY_LIST,
    childs: [],
  });

  static PageSleepStories = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#sleep-stories",
    prefix: "page-sleep-story",
    name: "Сонные истории",
    routeName: SLEEP_STORY_LIST,
    childs: [
      MenuItemFactory.PageSleepStoriesPage,
      MenuItemFactory.PageSleepStoryCategories,
    ],
  });

  static PageAnimations = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#animations",
    prefix: "",
    name: "Анимации",
    routeName: ANIMATION_LIST,
    childs: [],
  });
  static PageLanguages = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#languages",
    prefix: "",
    name: "Список языков",
    routeName: LANGUAGES_LIST,
    childs: [],
  });
  static PageReminders = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#reminders",
    prefix: "",
    name: "Напоминания",
    routeName: REMINDER_LIST,
    childs: [],
  });
  static PageBreathings = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#breathing",
    prefix: "",
    name: "Дыхание",
    routeName: BREATHING_LIST,
    childs: [],
  });
  static PageDocuments = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#affirmations",
    prefix: "",
    name: "Документы",
    routeName: DOCUMENTS,
    childs: [],
  });
  static PageStatistics = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#statistics",
    prefix: "",
    name: "Статистика",
    routeName: STATISTICS,
    childs: [],
  });

  static PageLevels = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#statistics",
    prefix: "",
    name: "Уровни",
    routeName: LEVEL_LIST,
    childs: [],
  });

  static PageRewards = new MenuItem({
    icon: "/assets/img/svg-sprite.svg#promocode",
    prefix: "",
    name: "Награды",
    routeName: REWARD_LIST,
    childs: [],
  });

  /**
   * Меню проектов конец
   */
}
export default class MenuFactory {
  private static ProjectMenu = [
    MenuItemFactory.PageMeditation,
    MenuItemFactory.PageAffirmations,
    MenuItemFactory.PageMusic,
    MenuItemFactory.PageUsers,
    MenuItemFactory.PagePromocode,
    MenuItemFactory.PageEmailPush,
    MenuItemFactory.PageInspiration,
    MenuItemFactory.PageSleepStories,
    MenuItemFactory.PageAnimations,
    MenuItemFactory.PageLanguages,
    MenuItemFactory.PageReminders,
    MenuItemFactory.PageBreathings,
    MenuItemFactory.PageDocuments,
    MenuItemFactory.PageStatistics,
    MenuItemFactory.PageLevels,
    MenuItemFactory.PageRewards,
  ];

  static getProjectMenu(): MenuItem[] {
    this.addParams(this.ProjectMenu, {});
    let menuItems: MenuItem[] = this.ProjectMenu;
    return menuItems;
  }
  static addParams(menu: MenuItem[], params: Object) {
    menu.forEach((item) => {
      item.routeParameters = params;
      if (item.childs.length > 0) {
        this.addParams(item.childs, params);
      }
    });
  }
}
